/**
 * The public URL of one provider: `/servicii/furnizori/<slug>`.
 *
 * Same shape as eventPath.ts/forumPath.ts: the slug comes straight from the API, assigned once
 * at registration from the organization's name and never recomputed, so a link stays valid even
 * if the provider is later renamed.
 */
export function providerPath(provider: { slug: string }): string {
  return `/servicii/furnizori/${provider.slug}`;
}
